
import { defineComponent } from 'vue'
import { AxiosResponse } from 'axios'
import Dialog from 'primevue/dialog'
import InlineMessage from 'primevue/inlinemessage'
import olapSaveNewVersionDialogDescriptor from './OlapSaveNewVersionDialogDescriptor.json'
import Textarea from 'primevue/textarea'

export default defineComponent({
    name: 'olap-save-new-version-dialog',
    components: { Dialog, InlineMessage, Textarea },
    props: { visible: { type: Boolean }, id: { type: String } },
    emits: ['close', 'save', 'newVersionSaved'],
    computed: {},
    data() {
        return {
            olapSaveNewVersionDialogDescriptor,
            version: { name: '', descr: '' } as { name: string; descr: string },
            loading: false
        }
    },
    watch: {},
    created() {},
    methods: {
        close() {
            this.$emit('close')
            this.version = { name: '', descr: '' }
        },
        async save() {
            this.loading = true
            await this.$http
                .post(
                    process.env.VUE_APP_OLAP_PATH + `1.0/model/saveAs?SBI_EXECUTION_ID=${this.id}`,
                    { name: this.version.name !== '' ? this.version.name : 'sbiNoDescription', descr: this.version.descr !== '' ? this.version.descr : 'sbiNoDescription' },
                    { headers: { Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json;charset=UTF-8', 'X-Disable-Errors': 'true' } }
                )
                .then((response: AxiosResponse<any>) => {
                    this.$store.commit('setInfo', {
                        title: this.$t('common.toast.createTitle'),
                        msg: this.$t('common.toast.success')
                    })
                    this.$emit('newVersionSaved', response.data)
                    this.close()
                })
                .catch((error: any) =>
                    this.$store.commit('setError', {
                        title: this.$t('common.error.generic'),
                        msg: error?.localizedMessage
                    })
                )
            this.loading = false
        }
    }
})
